import {
  all, call, fork, put, takeEvery, select,
} from 'redux-saga/effects';
import { ConfigActionTypes } from './types';
import { configSuccess, configError } from './actions';
import { pageRequest } from '../page/actions';
import apiRequest from '../../utils/apiReq';
import { attachStyle } from '../../utils/base';

function* handleConfigRequest(action: any) {
  // Check if config is already initialized from server-side data
  const currentConfig = yield select((state: any) => state.config?.data);
  const hasConfig = currentConfig && Object.keys(currentConfig).length > 0;
  
  if (hasConfig) {
    console.log('Config already initialized from server-side data, skipping API request');
    yield put(pageRequest({ location: { ...action.payload } }));
    return;
  }
  
  const { code, data } = yield call(apiRequest, 'get', '/config');
  if (code === 200) {
    yield put(
      configSuccess({
        data: { ...data },
      }),
    );

    if (data.style) {
      attachStyle(data.style);
    }
    yield put(pageRequest({ location: { ...action.payload } }));
  } else {
    yield put(configError());
  }
}

function* handleConfigEmptyRequest() {
  // Check if config is already initialized from server-side data
  const currentConfig = yield select((state: any) => state.config?.data);
  const hasConfig = currentConfig && Object.keys(currentConfig).length > 0;
  
  if (hasConfig) {
    console.log('Config already initialized from server-side data, skipping API request');
    return;
  }
  
  const { code, data } = yield call(apiRequest, 'get', '/config');
  if (code === 200) {
    if (data.style) {
      attachStyle(data.style);
    }

    yield put(
      configSuccess({
        data: { ...data },
      }),
    );
  } else {
    yield put(configError());
  }
}

function* watchFetchRequest() {
  yield takeEvery(ConfigActionTypes.CONFIG_REQUEST, handleConfigRequest);
  yield takeEvery(ConfigActionTypes.CONFIG_EMPTY_REQUEST, handleConfigEmptyRequest);
}

function* configSaga() {
  yield all([fork(watchFetchRequest)]);
}

export default configSaga;
